import useBreadcrumbs from 'use-react-router-breadcrumbs'

const Header = () => {
  const routes = [
    { path: '/', props: { value: 'Home' }},
    { path: '/user', props: { value: 'User' }},
    { path: '/user/create', props: { value: 'Create user' }},
    { path: '/user/*', props: { value: 'Edit user' }},
    { path: '/settings', props: { value: 'Settings' }},
    { path: '/settings/enable2fa', props: { value: 'Enable two factor authentication' }},
    { path: '/client', props: { value: 'Client' }},
    { path: '/client/create', props: { value: 'Create client' }},
    { path: '/client/board', props: { value: 'Client board' }},
    { path: '/client/delete/*', props: { value: 'Delete client' }},
    { path: '/client/*', props: { value: 'Edit client' }},
    { path: '/tag', props: { value: 'Tag' }},
    { path: '/tag/create', props: { value: 'Create tag' }},
    { path: '/tag/delete/*', props: { value: 'Delete tag' }},
    { path: '/tag/*', props: { value: 'Edit tag' }},
    { path: '/sector', props: { value: 'Sector' }},
    { path: '/sector/create', props: { value: 'Create sector' }},
    { path: '/sector/delete/*', props: { value: 'Delete sector' }},
    { path: '/sector/*', props: { value: 'Edit sector' }},
    { path: '/status', props: { value: 'Status' }},
    { path: '/status/*', props: { value: 'Edit status' }},
    { path: '/*', props: { value: '404 Not found' }},
  ]
  const breadcrumbs = useBreadcrumbs(routes)
  const active = breadcrumbs[breadcrumbs.length - 1].value

  return (
    <div className="app-content-header">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-6">
            <h2>{active}</h2>
          </div>
          <div className="col-sm-6">
            <ol className="breadcrumb float-sm-end">
              {breadcrumbs.map((breadcrumb) => active === breadcrumb.value ? null : <li className="breadcrumb-item" key={breadcrumb.value}><a href={breadcrumb.key}>{breadcrumb.value}</a></li>)}
              <li className="breadcrumb-item active" aria-current="page" key={active}>{active}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  )
}
   
export default Header